import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES, pendencySuccess, pendencyError } from 'store/reducers/pendency'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { getPendency as getPendencyService } from 'services'
import messages from 'config/messages'

const { PENDENCY_REQUEST } = ACTION_TYPES

export function *getPendency() {
  try {
    const response = yield call(getPendencyService)
    yield put(pendencySuccess(response))
  } catch (err) {
    yield put(pendencyError(err))
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: messages.requestError.title, type: 'error' }
    })
  }
}

export default function *watchPendency() {
  yield takeLatest(PENDENCY_REQUEST, getPendency)
}
